import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/main/index.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "about" */ '../views/register/index.vue')
    },
    {
        path: '/company-profile',
        name: 'CompanyProfile',
        component: () => import(/* webpackChunkName: "about" */ '../views/company-profile/index.vue')
    },
    {
        path: '/smart-cost-analysis',
        name: 'SmartCostAnalysis',
        component: () => import(/* webpackChunkName: "about" */ '../views/smart-cost-analysis/index.vue')
    },
    {
        path: '/',
        name: 'main',
        component: Main
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
